// Single source of design tokens (consumed by tailwind.config.js and JS components)
module.exports = {
  colors: {
    ink: "#0F1014",
    surface: "#1A1B21",
    elevated: "#24252C",
    line: "#2E2F38",
    gold: "#CC9440",
    "gold-soft": "#E8BE6A",
    ivory: "#F3F3F4",
    mist: "#9E9EA8",
    faint: "#686973",
    confirmed: "#6FCF97",
    cancelled: "#E57373",
  },
  fonts: {
    display: ["Fraunces", "Cormorant Garamond", "Georgia", "serif"],
    body: ["Geist", "Manrope", "Helvetica Neue", "sans-serif"],
  },
  map: {
    // CARTO dark tiles now need a key; without one we use OSM tiles with a dark CSS filter
    cartoTiles: "https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}{r}.png?key=",
    osmTiles: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    cartoAttribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
    osmAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    center: [33.749, -84.388],
    zoom: 11,
  },
};
